import { TreeMenuItemBaseType, TreeMenuItemPrimaryType, TreeMenuItemSourceType } from '../../../../models/find-content';
import classNames from 'classnames';
import classes from '../TreeMenu/TreeMenu.module.scss';
import { SocialNetwork } from '../../../../components/socialProfiles/SocialNetwork';
import { Icon } from '../../../../components/images/Icon/Icon';
import React from 'react';
import { RssIcon } from '../RssIcon';
import { DraggableTypesObject } from '../../../../constants/drag-and-drop';

export const TreeMenuItemPreview = (
  item: (TreeMenuItemPrimaryType | TreeMenuItemSourceType) & TreeMenuItemBaseType
): JSX.Element => {
  const itemClasses = classNames(classes.TreeMenuItemPreview, {
    [classes.TreeMenuItemPreviewFOLDER]: item.type === DraggableTypesObject.MENU_TREE_FOLDER,
    [classes.TreeMenuItemPreviewSOCIAL]: item.type === DraggableTypesObject.MENU_TREE_SOURCE
  });

  const iconClasses = classNames({
    [classes.SocialIcon]: item.type === DraggableTypesObject.MENU_TREE_SOURCE,
    [classes.StandardIcon]: item.type !== DraggableTypesObject.MENU_TREE_SOURCE
  });

  const labelWrapperClasses = classNames('cell shrink one-liner');

  const icon =
    item.type === DraggableTypesObject.MENU_TREE_SOURCE && !item.icon && item.provider !== 'RSS' ? (
      <SocialNetwork
        {...{
          provider: item.provider,
          network: item.network,
          size: 'small',
          type: 'circle'
        }}
      />
    ) : item?.icon ? (
      <Icon name={item.icon} size={'medium'} />
    ) : item.type === DraggableTypesObject.MENU_TREE_SOURCE && item.provider === 'RSS' ? (
      <RssIcon size={'small'} type={'circle'} />
    ) : undefined;

  const contentDataWrapperClasses = classNames('grid-x align-left');

  return (
    <div className={itemClasses}>
      <div className={'grid-x align-justify'}>
        <div className={'cell shrink'}>
          <div className={contentDataWrapperClasses}>
            <div className={iconClasses}>{icon}</div>
            <div className={labelWrapperClasses}>{item.label}</div>
          </div>
        </div>
        <div className={`cell shrink ${classes.DotMenu}`}></div>
      </div>
    </div>
  );
};
